module.exports = __webpack_public_path__ + "img/proyecto_14_mv.80e8b00c.webp";